/* global angular */

var ngModule = angular.module('trends');

ngModule.factory('AjaxList', ['Monitor', '$q',
    function (Monitor, $q) {
        function AjaxList(resource, opts) {
            opts = opts || {};

            this.pages = []; // May be sparse
            this.items = [];

            // If true, we can iterate the entire list
            this.contiguous = opts.contiguous !== undefined ? opts.contiguous : true;

            this.resource = resource;
            this.another_resource = opts.another_api || null;
            this.loader = new Monitor();
            this.canceller = null;
            this.cached = opts.cached || false;
            this.defaultParams = opts.defaultParams || null;
            this.pageSize = opts.pageSize || -1; // -1 indicates to load the entire list

            this.reset();
        }

        /*
         * Loads a specific page from the server into this list.
         *
         * If `force` is falsy, this method does nothing if something
         * is already loading. Otherwise, the current load operation is cancelled.
         *
         * This method always does nothing if the entire list has been loaded.
         */
        AjaxList.prototype.load = function (index, params, force) {
            if ((!force && this.isLoading()) || this.isFullyLoaded()) {
                // load(.., .., false).then() can 'undefined is not a function' here
                return false;
            }
            if (index !== this.page + 1 && this.isIterable()) {
                throw new Error('Cannot load arbitrary pages in an iterable AjaxList');
            }

            params = angular.copy(params) || {};

            if (this.isPaged()) {
                var offset = index * this.pageSize;
                var limit = this.pageSize;
                if (this.another_resource) {
                    if (!index) {
                        limit = 8;
                    } else if (index < 3) {
                        offset -= 1;
                        limit -= 1;
                    }
                }
                angular.extend(params, {offset: offset, limit: limit});
            }
            if (this.defaultParams) {
                angular.extend(params, this.defaultParams);
            }

            this.error = ''; // reset an existing error at any loading attempt

            var that = this;
            var canceller = $q.defer(); // Create a cancellable promise
            var config = {cache: this.cached, timeout: canceller.promise};
            var trends_promise = this.resource.withHttpConfig(config).getList(params);
        if (this.resource.route === 'trend' && this.another_resource !== null && index < 3) {
                // Send request to trend
                // Send request to trendpdf
                var static_trends_promotion_promise = this.another_resource.withHttpConfig(
                    config
                ).getList({offset:2-index, limit:1});
                $q.all([static_trends_promotion_promise, trends_promise]).then(
                    function (data) {
                        var data_list = $.merge(data[0], data[1]);
                        data_list.meta.total_count = data[1].meta.total_count;
                        that.loadSuccess(data_list, index);
                    },
                    function (data) {
                        // on fail record the error
                        that.error = data.data;
                    }
                );
            } else {
                trends_promise.then(
                    function (data) {
                        that.loadSuccess(data, index);
                    },
                    function (data) {
                        // on fail record the error
                        that.error = data.data;
                    }
                );
            }


            return this.loader.watch(trends_promise, canceller);
        };

        /*
         * Loads the next batch of data into this list using `load`.
         *
         * If the list is non-paged, this method will load the entire
         * list. Otherwise, the next page of content will be loaded.
         */
        AjaxList.prototype.loadNext = function (params, force) {
            return this.load(this.page + 1, params, force);
        };

        AjaxList.prototype.loadSuccess = function (data, index) {
            this.maxItems = data.meta.total_count;

            if (this.isPaged()) {
                // Clamp to max pages -- this might happen if the API returns
                // less results than expected
                index = Math.min(index, this.getMaxPage());
            }

            if (this.isIterable()){
                this.items.push.apply(this.items, data);
            }

            this.numItems += data.length;
            this.pages[index] = data;
            this.page = index;
        };

        /* Move to a specific page, loading more pages if required using `load`. */
        AjaxList.prototype.moveToPage = function (index, params, force) {
            if (this.pages[index]) {
                this.page = index;

                // Return a promise (even though we already the page)
                var deferred = $q.defer();
                deferred.resolve(this.pages[index]);
                return deferred.promise;
            } else {
                return this.load(index, params, force);
            }
        };

        AjaxList.prototype.reset = function () {
            this.maxItems = null; // Null indicates unknown
            this.pages.length = 0;
            this.page = -1;
            this.items.length = 0;
            this.numItems = 0;
            this.error = '';
            this.loader.cancel();
        };

        /* Returns the full list of items if the list is iterable. */
        AjaxList.prototype.getItems = function () {
            if (!this.isIterable()) {
                throw new Error('getItems is only available on an iterable ajax list');
            }
            return this.items;
        };

        /* Get the current page. */
        AjaxList.prototype.getCurrentPage = function () {
            return this.getPage(this.page);
        };

        /* Get the page with page number `n`. */
        AjaxList.prototype.getPage = function (n) {
            return this.pages[n];
        };

        AjaxList.prototype.getMaxPage = function () {
            return this.isPaged() ? Math.ceil(this.maxItems / this.pageSize) - 1 : 0;
        };

        AjaxList.prototype.getNumPages = function () {
            return this.getMaxPage() + 1;
        };

        /*
         * Return true if the AjaxList is iterable, false otherwise.
         * An AjaxList is iterable if either it is contiguous or unpaged.
         */
        AjaxList.prototype.isIterable = function() {
            return this.contiguous || !this.isPaged();
        };

        AjaxList.prototype.isPaged = function () {
            return this.pageSize > 0;
        };

        AjaxList.prototype.isLoading = function () {
            return this.loader.isBusy();
        };

        AjaxList.prototype.isFullyLoaded = function () {
            return this.maxItems !== null && this.numItems >= this.maxItems;
        };

        AjaxList.prototype.isEmptyResult = function () {
            return this.numItems === 0 && this.isFullyLoaded();
        };

        AjaxList.prototype.lastLoadErrored = function() {
            return this.error !== '';
        };

        return AjaxList;
    }]);
